import axios from "../../../utils/axios";
import { refreshConnection } from "../../../web-socket";
import { removeLocalStorageItems } from "../../../utils/common-utils";
import { clearTokens } from "../../../lib/api/tokenStore";
import { clearProfile } from "../../../features/profile/profileStore";
import { authenticationSliceActions } from "./authentication-Slice";

const LOGOUT_STORAGE_KEYS = [
  "user",
  "consumer-data",
  "phoneNumber",
  "carts",
  "reservationInfo",
  "freePayment",
  "tokenExpiry",
  "refillTerms",
  "swapGoTerms",
  "redirectPath",
];

export const setTraceIdForIdentification = (traceId) => {
  return (dispatch) =>
    dispatch(authenticationSliceActions.setIdentificationTraceId(traceId));
};

export const setConsumerPhoneNumber = (phoneNumber) => {
  return (dispatch) =>
    dispatch(authenticationSliceActions.setUserPhoneNumber(phoneNumber));
};

export const setUserExistence = (userExists) => {
  return (dispatch) =>
    dispatch(authenticationSliceActions.setUsetExists(userExists));
};

export const setAuthToken = (authToken) => {
  return (dispatch) =>
    dispatch(authenticationSliceActions.setUserAuthToken(authToken));
};

export const setRefreshToken = (user) => {
  return (dispatch) => {
    dispatch(authenticationSliceActions.setUser(user));
  };
};

export const setUserToken = (userToken) => {
  return (dispatch) => {
    dispatch(authenticationSliceActions.setUserAuth(userToken));
  };
};

export const setOperations = (operations) => {
  return (dispatch) => {
    dispatch(authenticationSliceActions.setUserOperations(operations));
  };
};

/**
 * Logout is entirely local.
 *
 * It used to await an FCM push-unsubscribe first. Web push is gone — the
 * `/notifications/push/subscribe/` pair is a mobile-only API — so there is
 * no token registered to retract, and nothing left that can hold the
 * session open while the user waits.
 */
export const logoutUser = (loginCB) => {
  return (dispatch) => {
    removeLocalStorageItems(LOGOUT_STORAGE_KEYS);

    dispatch(authenticationSliceActions.logoutUser());

    clearTokens();
    clearProfile();

    loginCB && loginCB();

    return refreshConnection().catch(console.error);
  };
};

export const setNewNotification = (notification) => {
  return (dispatch) => {
    dispatch(authenticationSliceActions.setNotificationToggle(notification));
  };
};

export const refreshAuth = async (refreshToken) => {
  return await axios.post("/login/refresh/", { refreshToken }, {}, true);
};

export const getProfile = async () => {
  return await axios.get("/consumers/self/");
};
